// state
import { useState, useContext } from "react";

// api
import API from "../api/api";

// router
import { useNavigate } from "react-router-dom";

// context
import { AuthContext } from "../context/AuthContext";

// icon
import { ImSpinner2 } from "react-icons/im";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await API.post("/auth/login", { username, password });

      login(res.data.token);

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("username", res.data.username);
      localStorage.setItem("name", res.data.name);
      navigate("/home");
    } catch (err) {
      setError(err.response?.data?.msg || "Erro ao fazer login");
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gradient-to-r from-gray-100 via-gray-200 to-gray-300">
      <form
        onSubmit={handleSubmit}
        className="w-full mx-3 md:mx-0 md:w-96 bg-white p-8 rounded-2xl shadow-2xl flex flex-col items-center border border-gray-200"
      >
        <div className="mb-6">
          <div className="w-32">
            <img
              src="./img/logo.jpg"
              alt="Logo barbearia"
              className="rounded-full shadow-md"
            />
          </div>
        </div>

        {error && <p className="text-red-500 mb-4">{error}</p>}

        <input
          type="text"
          placeholder="Usuário"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          className="w-full mb-4 p-3 rounded-md border border-gray-300 bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-800"
        />

        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="w-full mb-4 p-3 rounded-md border border-gray-300 bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-800"
        />

        <button
          type="submit"
          className="w-full bg-gray-900 text-white p-3 rounded-lg hover:bg-gray-800 transition-all text-center flex justify-center items-center"
        >
          {loading ? (
            <ImSpinner2 className="animate-spin text-white" size={20} />
          ) : (
            "Entrar"
          )}
        </button>
      </form>
    </div>
  );
}
